import * as Yup from 'yup';

export default Yup.object({
  number: Yup.string()
    .length(22, 'Debe tener largo 22')
    .matches(/^\d+$/, 'Debe contener solo números')
    .required('Campo obligatorio'),
});
